// ============================================
// Auth - Index Module (ES6)
// 진입점 및 통합 관리
// ============================================

// Sub-modules
export * from './state.js';
export * from './firebase.js';
export * from './login.js';
export * from './splash.js';
export * from './user.js';

// Re-import for Auth object
import {
  getStorage, getCurrentUser,
  getUserCarbon, setUserCarbon, getUserNickname,
  getCachedProfiles, setCachedProfiles,
  getCachedPrimaryProfileId, setCachedPrimaryProfileId,
  getPrimaryProfile
} from './state.js';

import { initializeFirebase } from './firebase.js';

import {
  showLoginModal, closeLoginModal, requireLogin,
  showSignupMode, showLoginMode, handleAuth,
  handleGoogleLogin, handleLogout,
  showEmailLoginModal, closeEmailLoginModal,
  showEmailVerificationModal, closeEmailVerificationModal,
  resendVerificationEmail, checkEmailVerification,
  showResetPasswordModal, closeResetPasswordModal,
  sendPasswordResetEmail
} from './login.js';

import {
  initSplashAnimation, stopSplashAnimation,
  showSplashAuth, hideSplashAuth
} from './splash.js';

import {
  loadUserData, updateNicknameDisplay, updateAvatarDisplay,
  updateCarbonDisplay,
  openNicknameModal, closeNicknameModal, saveNickname,
  checkAdminStatus
} from './user.js';

// ============================================
// Auth 객체 (하위 호환성)
// ============================================

export const Auth = {
  // Firebase
  initializeFirebase,
  getStorage,
  // Login
  showLoginModal,
  closeLoginModal,
  requireLogin,
  showSignupMode,
  showLoginMode,
  handleAuth,
  handleGoogleLogin,
  handleLogout,
  showEmailLoginModal,
  closeEmailLoginModal,
  // Email Verification
  showEmailVerificationModal,
  closeEmailVerificationModal,
  resendVerificationEmail,
  checkEmailVerification,
  // Password Reset
  showResetPasswordModal,
  closeResetPasswordModal,
  sendPasswordResetEmail,
  // Splash
  showSplashAuth,
  hideSplashAuth,
  initSplashAnimation,
  stopSplashAnimation,
  // User Data
  loadUserData,
  updateNicknameDisplay,
  openNicknameModal,
  closeNicknameModal,
  saveNickname,
  updateCarbonDisplay,
  checkAdminStatus,
  // Getters/Setters
  getCurrentUser,
  getUserCarbon,
  setUserCarbon,
  getUserNickname,
  getCachedProfiles,
  setCachedProfiles,
  getCachedPrimaryProfileId,
  setCachedPrimaryProfileId,
  getPrimaryProfile
};

// ============================================
// window 노출 제거됨 (2026-01-06)
// 모든 호출이 ES6 import로 처리됨
// - showLoginModal, loadUserData, updateCarbonDisplay
// - getCachedPrimaryProfileId, setCachedPrimaryProfileId
// - openNicknameModal, closeNicknameModal, saveNickname
// ============================================

// ============================================
// 초기화
// ============================================

document.addEventListener('DOMContentLoaded', () => {
  initSplashAnimation();
});

console.log('auth/index.js (ES6 module) loaded successfully');
